module.exports = __webpack_public_path__ + "img/covers.3eb82b7d.webp";